// Centralized API configuration
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

export const API_ENDPOINTS = {
  // Authentication
  login: `${API_BASE_URL}/login`,
  resetCallStatus: `${API_BASE_URL}/reset-call-status`,
  
  // Excel operations
  latestExcel: `${API_BASE_URL}/latest-excel`,
  uploadExcel: `${API_BASE_URL}/upload-excel`,
  previewExcel: `${API_BASE_URL}/preview-excel`,
  refreshExcelUrl: `${API_BASE_URL}/refresh-excel-url`,
  
  // Campaign operations
  startCampaign: `${API_BASE_URL}/start-campaign`,
  streamTranscript: (sessionId: string) => `${API_BASE_URL}/stream-transcript/${sessionId}`,
  
  // Dashboard
  dashboard: `${API_BASE_URL}/dashboard`,
  
  // Settings - specific uploads
  uploadExcelPlans: `${API_BASE_URL}/upload-excel/plans`,
  uploadExcelDevices: `${API_BASE_URL}/upload-excel/devices`,
  
  // Survey operations
  surveyResponses: `${API_BASE_URL}/survey-responses`,
  resetSurveyResponses: `${API_BASE_URL}/reset-survey-responses`,
  finalizeDelete: `${API_BASE_URL}/finalize-delete`,
  
  // Testing operations
  startSimpleCall: `${API_BASE_URL}/start-simple-call`,
  simulateCalls: `${API_BASE_URL}/simulate-calls`,
  
  // Corrections
  corrections: `${API_BASE_URL}/corrections`,
};

export default API_BASE_URL;